import React, { use } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import DesoExternalIdTextField from 'shared/components/deso-external-id-text-field/deso-external-id-text-field';
import G2ExternalIdTextField from 'shared/components/g2-external-id-text-field/g2-external-id-text-field';
import { DeviceType } from 'shared/models/device-type';

import LinkableTransmitterStepsProviderContext from 'features/residents/resident-settings/components/resident-setting-details/components/devices-accordion/components/details-devices/components/linkable-transmitter-steps/providers/contexts/linkable-transmitter-steps-provider-context';
import useEnterDeviceIdStep from './hooks';
import styles from './enter-device-id-step.module.scss';

const EnterDeviceIdStep = (): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings', { keyPrefix: 'linkableDevicesModal.linkableTransmitterSteps' });
  const { form } = use(LinkableTransmitterStepsProviderContext);

  const { deviceType, registerOptions } = useEnterDeviceIdStep(form);

  const renderExternalIdInputField = (): React.JSX.Element => {
    if (deviceType === DeviceType.DesoResidentTransmitter) {
      return (
        <Controller
          name="externalId"
          control={form.control}
          rules={registerOptions.externalIdDesoTransmitter}
          render={({ field }) => <DesoExternalIdTextField field={field} errors={form.formState.errors} />}
        />
      );
    }

    return (
      <Controller
        name="externalId"
        control={form.control}
        rules={registerOptions.externalIdG2}
        render={({ field }) => <G2ExternalIdTextField field={field} errors={form.formState.errors} />}
      />
    );
  };

  return (
    <div className={styles.enterDeviceIdStepContainer}>
      <div className={styles.deviceIdCard}>
        <Typography variant="h6">{t('deviceExternalId')}</Typography>
        {renderExternalIdInputField()}
      </div>
    </div>
  );
};

export default EnterDeviceIdStep;
